var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.vueAppClasses,attrs:{"id":"app"}},[_c('router-view',{on:{"setAppClasses":_vm.setAppClasses}}),_c('portal-target',{attrs:{"name":"modal-root"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }